module.exports = __webpack_public_path__ + "img/syllabus_imge1.487b466e.png";